import {Component} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IonicHelper } from "../../../helpers/ionic.helper";
import { AuthService } from "../../../services/auth.service";
import { NavController } from "ionic-angular";
import { ViewDidEnter } from "../../../app/app.interfaces";

@Component({
  selector: 'login',
  templateUrl: 'register.html',
})
export class Register implements ViewDidEnter {

  form: FormGroup;  
  
  constructor(private formBuilder: FormBuilder, 
              private nav: NavController,
              private ionic: IonicHelper, 
              private authService: AuthService) { 
    
  }


  ionViewDidEnter(): void {
    
    this.form = this.formBuilder.group({
        email: ['', Validators.compose([Validators.maxLength(60), Validators.email, Validators.required])]
    });
  }

  submitForm(){
    
    if(this.form.valid){
    
      // this.ionic.toggleLoader();
      
      // console.log(this.form.value.email);
      
      this.authService.requestUserRegistration(this.form.value.email).then((response: any) => {
        this.ionic.toggleLoader(false);
        this.ionic.alert({ message: 'LOGIN.REGISTER_SUCCES', 
          context: { email: this.form.value.email } }, 'GLOBAL.SUCCESS').subscribe(()=>{
            this.nav.setRoot('login');
        });
      }, (error) => {
        this.ionic.toggleLoader(false);        
        let errMsg = (error==='Invalid request') ? 'GLOBAL.GENERAL_ERROR':'LOGIN.REGISTER_ERROR.'+error;
        this.ionic.alert(errMsg);        
      }); 
    }
    else {
      this.ionic.toggleLoader(false);
      this.ionic.alert('LOGIN.REGISTER_ERROR.FORM_INVALID');
    }
    
  }
  
}


// WEBPACK FOOTER //
// ./src/components/login/register/register.ts